import { OidcMetadataConfig } from "../types/oidc-metadata-config";

export const OIDC_METADATA_CONFIG: OidcMetadataConfig = {
    issuer: '{oidc_authority}',
    jwks_uri: '{oidc_authority}/.well-known/openid-configuration/jwks',
    authorization_endpoint: '{oidc_authority}/connect/authorize',
    token_endpoint: '{oidc_authority}/connect/token',
    userinfo_endpoint: '{oidc_authority}/connect/userinfo',
    end_session_endpoint: '{oidc_authority}/connect/endsession',
    check_session_iframe: '{oidc_authority}/connect/checksession',
    revocation_endpoint: '{oidc_authority}/connect/revocation'
}
